import React from 'react';
import {
  Banner,
  Button,
  FluidButtonLayout,
  Layout,
  ParagraphHeader,
  ReadonlyTextarea,
} from '@axiom/ui';
import type { CandidateEngagementDetails } from '@axiom/validation';

export type EngagementsViewStateBannerWarmedProps = {
  engagement: CandidateEngagementDetails;
  name?: string;
  onWarmedNo: () => void;
  onWarmedYes: () => void;
};

export const EngagementsViewStateBannerWarmed: React.FC<
  EngagementsViewStateBannerWarmedProps
> = ({
  engagement,
  name = 'ENGAGEMENTS_VIEW_STATE_BANNER_WARMED',
  onWarmedNo,
  onWarmedYes,
}) => {
  return (
    <Banner name={name} type="critical" impact="high">
      <Layout direction="vertical" verticalGutter="24px">
        <ParagraphHeader name="WARMED_HEADER">
          Interested in this opportunity?
        </ParagraphHeader>
        <ReadonlyTextarea
          name="WARMED_MESSAGE"
          value={engagement.candidateStatusMessage}
        />
        <FluidButtonLayout stackableOn="mobile">
          <Button
            name="pendo-new-submission-no-button"
            variation="outline"
            onClick={() => {
              onWarmedNo();
            }}
          >
            No
          </Button>
          <Button
            name="pendo-new-submission-yes-button"
            onClick={() => {
              onWarmedYes();
            }}
          >
            Yes
          </Button>
        </FluidButtonLayout>
      </Layout>
    </Banner>
  );
};
